import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import { get, isEmpty } from "lodash";
import { Route, Routes, useLocation } from "react-router-dom";
import { Toast } from "primereact/toast";
import VinSearchList from "./partials/VinSearchList";

const SearchVins = (props: any) => {
    const { t } = props;
    const toast = useRef(null);
    const { state } = useLocation();
    const vinNumbersFromState = get(state, ["vin_numbers"]);
    const [moduleState, setModuleState] = useState<any>({
        page: 1,
        per_page: 20,
        search: null,
        initialized: false,
        filters: {},
    });

    useEffect(() => {
        document.title = t("search");

        setModuleState({
            page: 1,
            per_page: 20,
            search: null,
            initialized: true,
            filters: {
                vin_numbers: vinNumbersFromState,
            },
        });
    }, []);

    useEffect(() => {
        if ( vinNumbersFromState && !isEmpty(vinNumbersFromState) && moduleState.initialized ) {
            setModuleState({
                ...moduleState,
                page: 1,
                filters: {
                    ...(moduleState.filters || {}),
                    vin_numbers: vinNumbersFromState,
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vinNumbersFromState]);

    const toastify = (message: any, color: string = 'info', summary: any = null) => {
        if ( toast && toast.current ) {
            // @ts-ignore
            toast.current.show({ severity: color, summary: summary, detail: message });
        }
    };

    return (
        <div className={ "module-container" }>
            <Toast ref={ toast } />
            <div className="layout-content">
                { (moduleState && moduleState.initialized) ?
                    <React.Fragment>
                        <Routes>
                            <Route path={ "/" } element={
                                <VinSearchList
                                    moduleState={ moduleState }
                                    toastify={ toastify }
                                    setQuery={ setModuleState }
                                /> } />
                        </Routes>
                    </React.Fragment>
                    : <h6>{ t('loading') }</h6> }
            </div>
        </div>
    );
};

export default withTranslation()(SearchVins);
